Namespace 'Customer.Ticket'

class Customer.Ticket.AttributesValidationMessageBuilder

  constructor: ({ticketAttributesCollection, userProfileAttributesCollection, skipAttributesErrorDetail}) ->
    @ticketAttributesCollection = ticketAttributesCollection
    @userProfileAttributesCollection = userProfileAttributesCollection
    @skipAttributesErrorDetail = skipAttributesErrorDetail

  createValidationErrorMessage: (response) =>
    header = I18n.t('customer.dashboard.conversations.validation_error.header')
    return header if @skipAttributesErrorDetail
    """
      #{header}:
      <br><br>
      #{@buildTicketMessage(response.ticket_attribute_errors) || '' }
      #{@buildProfileMessage(response.user_profile_attribute_errors) || '' }
    """

  buildTicketMessage: (ticketAttributeErrors) ->
    return if _.isEmpty(ticketAttributeErrors)
    """
      #{I18n.t('customer.dashboard.conversations.validation_error.ticket')}:
      <br>
      #{@_createTicketAttributesMessage(ticketAttributeErrors)}
      <br><br>
    """

  buildProfileMessage: (userProfileAttributeErrors) ->
    return if _.isEmpty(userProfileAttributeErrors)
    """
      #{I18n.t('customer.dashboard.conversations.validation_error.profile')}:
      <br>
      #{@_createProfileAttributesMessage(userProfileAttributeErrors)}
    """

  _createTicketAttributesMessage: (ticketAttributeErrors) ->
    Object.keys(ticketAttributeErrors).map((code) =>
      attributeDefinition = @ticketAttributesCollection.findWhere({code: code}).get('definition')
      attributeName = attributeDefinition.get('name')
      attributeType = attributeDefinition.get('attribute_type_name')
      attributeTypeTranslation = I18n.t("monitoring.conversation_attributes.types.#{attributeType}")
      "#{attributeName} (#{attributeTypeTranslation})"
    ).join('<br>')

  _createProfileAttributesMessage: (userProfileAttributeErrors) ->
    Object.keys(userProfileAttributeErrors).map((code) =>
      attributeDefinition = @userProfileAttributesCollection.find((attribute) -> attribute.code == code)
      attributeName = attributeDefinition.name
      attributeType = attributeDefinition.attribute_type_name
      attributeTypeTranslation = I18n.t("monitoring.conversation_attributes.types.#{attributeType}")
      "#{attributeName} (#{attributeTypeTranslation})"
    ).join('<br>')
